export default function () {
    const delayedLinks = document.querySelectorAll('.projects__item-link');

    delayedLinks.forEach(link => {
        if (window.innerWidth < 992) {
            link.addEventListener('touchstart', function (event) {
                link.classList.add('hovered');
            });
        } else {
            link.addEventListener('click', function (event) {
                event.preventDefault();
                setTimeout(() => {
                    window.location.href = link.getAttribute('href');
                }, 1500);
            });
        }
    });
}